module.exports = __webpack_public_path__ + "static/media/development.0fa54833.jpg";